<ion-header>
    <ion-toolbar class="modal-toolbar">
        <div class="list-items-header">
            <div class="list-items-header-left">
                @let isIos = isIosPlatform$ | async;
                @if (isIos) {
                    <ion-button
                        class="back-btn-modal"
                        (click)="cancel()"
                        fill="clear"
                        slot="icon-only"
                    >
                        <ion-icon name="chevron-back-outline"></ion-icon>
                        {{ 'common.back' | translate }}
                    </ion-button>
                } @else {
                    <ion-button
                        class="back-btn-modal"
                        (click)="cancel()"
                        fill="clear"
                        slot="icon-only"
                    >
                        <ion-icon color="dark" name="arrow-back-outline"></ion-icon>
                    </ion-button>
                }
            </div>
            <ion-title>{{ 'update-modal.title' | translate }}</ion-title>
        </div>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="update-container">
        <div class="info-message">
            <div class="logo-app">
                <ion-icon name="cloud-download-outline"></ion-icon>
            </div>
            @let appInfo = appInfo$ | async;
            @if (appInfo) {
                <div class="info-message-title">
                    {{ appInfo.name }}
                </div>
            }
            <div class="info-message-body">
                {{ 'update-modal.message' | translate }}
            </div>
        </div>
        <ion-button
            (click)="openAppStore()"
            fill="clear"
            class="btn btn-outline-blue"
            type="submit"
            expand="full"
        >
            {{ 'update-modal.btn' | translate }}
        </ion-button>
    </div>
</ion-content>
